skrilla.controller('updateStreamUrisModalCtrl', function ($scope, modalService, searchService, cacheService) {
    $scope.match = cacheService.getObject("matchDetails");

    $scope.saveUri = function(){
        console.log($scope.match);
        searchService.put('matches/' + $scope.match.id + "/streamUri", {streamUri:$scope.match.streamUri}, "Stream URI Successfully updated").then(function(response){
            modalService.dismissAll();
        });
    }
});
